import { PARTNER } from "@/config/partner";
import { cn } from "@/lib/utils";

interface PartnerLogoProps {
  variant?: "logo" | "icon";
  className?: string;
}

export function PartnerLogo({ variant = "logo", className }: PartnerLogoProps) {
  const src = variant === "icon" ? PARTNER.icon : PARTNER.logo;

  if (src) {
    return (
      <img
        src={src}
        alt={PARTNER.name}
        className={cn(
          variant === "icon" ? "h-full w-full object-contain" : "h-full w-auto object-contain",
          className,
        )}
      />
    );
  }

  return (
    <span
      aria-label={PARTNER.name}
      className={cn(
        "inline-flex items-center justify-center font-display font-bold uppercase tracking-wide text-foreground leading-none",
        variant === "icon" ? "text-[0.6rem]" : "text-sm",
        className,
      )}
    >
      {PARTNER.displayName}
    </span>
  );
}

export default PartnerLogo;